"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_GROUPED_BALANCE_TRANSFERS = exports.MAX_DEBT_SWAP_TRANSFERS_PER_CHANNEL = exports.DisplayableBalanceTransferOrCashOutStatus = exports.BalanceTransferError = exports.BalanceTransferType = exports.CASH_OUT_SOURCE_QUERY_KEY = exports.AvenBalanceTransferSource = void 0;
var AvenBalanceTransferSource;
(function (AvenBalanceTransferSource) {
    AvenBalanceTransferSource["ActivationRequirement"] = "ActivationRequirement";
    AvenBalanceTransferSource["PrimeV3"] = "PrimeV3";
    AvenBalanceTransferSource["BalanceSweep"] = "BalanceSweep";
    AvenBalanceTransferSource["Operations"] = "Operations";
    /** user requested CashOut through the app */
    AvenBalanceTransferSource["CashOut"] = "CashOut";
    AvenBalanceTransferSource["HelocRefi"] = "HelocRefi";
    /** user requested BalanceTransfer through the app*/
    AvenBalanceTransferSource["BalanceTransfer"] = "BalanceTransfer";
    AvenBalanceTransferSource["BalanceTransferSweep"] = "BalanceTransferSweep";
    AvenBalanceTransferSource["RewardsBtUpsellSweep"] = "RewardsBtUpsellSweep";
    AvenBalanceTransferSource["RecurringBalanceTransfer"] = "RecurringBalanceTransfer";
    AvenBalanceTransferSource["EngagementSipOffer"] = "EngagementSipOffer";
    AvenBalanceTransferSource["CashToMerchant"] = "CashToMerchant";
    AvenBalanceTransferSource["CreditBalanceRefund"] = "CreditBalanceRefund";
    AvenBalanceTransferSource["DebtSwapBalanceTransfer"] = "DebtSwapBalanceTransfer";
    /** Customer-initiated cash out for a restricted-state merchant payment request */
    AvenBalanceTransferSource["RestrictedMerchantCashOut"] = "RestrictedMerchantCashOut";
    /** Ops-initiated wire to a settlement/escrow agent to fund a purchase (first-lien HELOC purchase settlement) */
    AvenBalanceTransferSource["HomePurchaseSettlement"] = "HomePurchaseSettlement";
    AvenBalanceTransferSource["RewardsBtAutosweep"] = "RewardsBtAutosweep";
})(AvenBalanceTransferSource || (exports.AvenBalanceTransferSource = AvenBalanceTransferSource = {}));
/**
 * Query param carrying the intended cash-out source into /cashOutHistory. The contractor tile sets it because
 * that screen resets the cash-out session state on mount, so the source cannot survive in session storage.
 * Shared here so the app and the e2e suite read the same key.
 */
exports.CASH_OUT_SOURCE_QUERY_KEY = 'cashOutSource';
var BalanceTransferType;
(function (BalanceTransferType) {
    BalanceTransferType["CreditCard"] = "CreditCard";
    BalanceTransferType["_PersonalLoan"] = "PersonalLoan";
    BalanceTransferType["CashOut"] = "CashOut";
    BalanceTransferType["HelocRefi"] = "HelocRefi";
    BalanceTransferType["InstantLiability"] = "InstantLiability";
    BalanceTransferType["CashToMerchant"] = "CashToMerchant";
    BalanceTransferType["Check"] = "Check";
    BalanceTransferType["AvenTransfer"] = "AvenTransfer";
    BalanceTransferType["AvenToAvenBalanceTransfer"] = "AvenToAvenBalanceTransfer";
    BalanceTransferType["HomePurchaseSettlement"] = "HomePurchaseSettlement";
})(BalanceTransferType || (exports.BalanceTransferType = BalanceTransferType = {}));
var BalanceTransferError;
(function (BalanceTransferError) {
    BalanceTransferError["INVALID_SINGLE_USE_TOKEN"] = "INVALID_SINGLE_USE_TOKEN";
    BalanceTransferError["FAILED_TO_ACQUIRE_LOCK"] = "FAILED_TO_ACQUIRE_LOCK";
    BalanceTransferError["INVALID_BANK_ACCOUNT"] = "INVALID_BANK_ACCOUNT";
    BalanceTransferError["FAILED_TO_REGISTER"] = "FAILED_TO_REGISTER";
})(BalanceTransferError || (exports.BalanceTransferError = BalanceTransferError = {}));
/**
 * Frontend-facing status for balance transfers and cash outs.
 * This maps the internal BalanceTransferStatus to user-friendly display values.
 */
var DisplayableBalanceTransferOrCashOutStatus;
(function (DisplayableBalanceTransferOrCashOutStatus) {
    DisplayableBalanceTransferOrCashOutStatus["Pending"] = "pending";
    DisplayableBalanceTransferOrCashOutStatus["Completed"] = "completed";
    DisplayableBalanceTransferOrCashOutStatus["Canceled"] = "canceled";
    DisplayableBalanceTransferOrCashOutStatus["Reversal"] = "reversal";
})(DisplayableBalanceTransferOrCashOutStatus || (exports.DisplayableBalanceTransferOrCashOutStatus = DisplayableBalanceTransferOrCashOutStatus = {}));
// Max number of balance transfers per channel (MethodFi or ACI) in a single debt swap registration request.
exports.MAX_DEBT_SWAP_TRANSFERS_PER_CHANNEL = 20;
// Max number of balance transfers that can be processed in a single grouped request (debt swap or trail data generation).
// This is a safety guard to prevent unbounded iteration over user-supplied arrays.
exports.MAX_GROUPED_BALANCE_TRANSFERS = 2 * exports.MAX_DEBT_SWAP_TRANSFERS_PER_CHANNEL;
